import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="font-heading text-xl md:text-2xl font-semibold mt-6 text-foreground-950">
          Strona nie została znaleziona
        </h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <a
          href="/"
          className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 text-sm font-medium text-background-50 bg-primary-600 hover:bg-primary-700 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-line text-sm"></i>
          </div>
          Powrót do strony głównej
        </a>
      </div>
    </div>
  );
}